import { useEffect, useState } from 'react';
import moment from 'moment';
import { Button, Link, Modal, Stack, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { useSnackbar } from 'notistack';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CampStepsBox from '../pages/campaign/form/CampStepsBox';
import { MUTATION_SEEN_ALL_NOTIFICATION, MUTATION_SEEN_NOTIFICATION } from '../graphql/notification';
import { MUTATION_FEATURE_SETTINGS, MUTATION_NOTIFICATION_STATUS } from '../graphql/appSetting';
import AppModal from './AppModal';

export default function NotificationModal({ open, onClose, notifications, appSettings, clicked, onUpdate }) {
  const [showNotification, setShowNotification] = useState(false);

  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [updateAppSettings] = useMutation(MUTATION_NOTIFICATION_STATUS);
  const [updateSeenNotification] = useMutation(MUTATION_SEEN_NOTIFICATION);
  const [markAllNotificationSeen] = useMutation(MUTATION_SEEN_ALL_NOTIFICATION);

  const updateNotificationStatus = async (e) => {
    setShowNotification(true);

    try {
      await updateAppSettings({
        variables: { NeverShowNotification: e.target.checked },
      });

      enqueueSnackbar(t('The feature has been changed successfully'), { variant: 'success' });
      setTimeout(onClose, 1000);
    } catch (err) {
      enqueueSnackbar(err?.graphQLErrors?.[0]?.message || t('An unexpected error has occurred'), { variant: 'error' });
    }
  };

  useEffect(() => {
    if (open) {
      if (clicked) {
        updateSeenNotification({ variables: { id: notifications[0]._id } });
      } else {
        markAllNotificationSeen();
      }
    }
  }, [open]);

  return (
    <AppModal
      open={open}
      onClose={onClose}
      maxWidth={1024}
      header={notifications.length > 1 ? t('Notifications') : t('Notification')}
      footer={
        !clicked && (
          <CampStepsBox active={showNotification}>
            <Typography>{t('Never show notification at top')}</Typography>
            <Switch checked={showNotification} labelPlacement="start" onChange={updateNotificationStatus} />
          </CampStepsBox>
        )
      }
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        {notifications?.map((notification, index) => (
          <div
            key={index}
            style={{
              backgroundColor: '#eee',
              borderRadius: 8,
              padding: 16,
            }}
          >
            <Typography variant="h4">{notification.Title}</Typography>
            <Typography
              variant="caption"
              color="#95A2B0"
              sx={{ marginBottom: 2, display: 'flex', alignItems: 'center', gap: 1 }}
            >
              <img src={`${process.env.PUBLIC_URL}/icons/clock.svg`} alt="Clock Icon" width={16} height={16} />
              {moment(notification.Date).fromNow()}
            </Typography>{' '}
            <Typography dangerouslySetInnerHTML={{ __html: notification.DescriptionHtml }} />
            <Link>{notification.MessageURL}</Link>
          </div>
        ))}
      </div>
    </AppModal>
  );
}
